export class DefApptResourceStrModel {
    def_appt_resource_category: string
    def_appt_resource_time_str: string
    def_appt_doctor_load: string

    constructor(
        def_appt_resource_category: string,
        def_appt_resource_time_str: string,
        def_appt_doctor_load: string,
    ) {
        this.def_appt_resource_category = def_appt_resource_category
        this.def_appt_resource_time_str = def_appt_resource_time_str
        this.def_appt_doctor_load = def_appt_doctor_load
    }
}

export class ApptResourceStrModel {
    appt_resource_category: string
    appt_resource_time_str: string
    appt_doctor_load: string

    constructor(
        appt_resource_category: string,
        appt_resource_time_str: string,
        appt_doctor_load: string,
    ) {
        this.appt_resource_category = appt_resource_category
        this.appt_resource_time_str = appt_resource_time_str
        this.appt_doctor_load = appt_doctor_load
    }
}

export class ApptResourceLoadModel {
    appt_resource_id: number
    appt_resource_code: string
    appt_resource_time_str: string
    appt_resource_category: string

    constructor(
        appt_resource_id: number,
        appt_resource_code: string,
        appt_resource_time_str: string,
        appt_resource_category: string,
    ) {
        this.appt_resource_id = appt_resource_id
        this.appt_resource_code = appt_resource_code
        this.appt_resource_time_str = appt_resource_time_str
        this.appt_resource_category = appt_resource_category
    }
}


import { PetTagHistModel } from "./pet-tag-hist.model"
export class AppointmentModel {
    appointment_id: number;
    dropoff_time_needed: number; // Represented as string for simplicity
    doctor_time_needed: number; // Represented as string for simplicity
    client_no: number;
    appointment_date: string;
    last_name: string;
    first_name: string;
    doctor: string;
    dropoff_time: string;
    dropoff: boolean;
    pet_no: number;
    pet_name: string;
    breed: string;
    color: string;
    appt_proc_id: number
    appt_proc_name: string;
    appointment_note: string;
    code1: string;
    code2: string;
    code3: string;
    code4: string;
    appt_fulfill: string;
    status: string;
    tag_no: PetTagHistModel[];
    unscheduled: boolean;

    constructor(
        appointment_id: number,
        dropoff_time_needed: number,
        doctor_time_needed: number,
        client_no: number,
        appointment_date: string,
        last_name: string,
        first_name: string,
        doctor: string,
        dropoff_time: string,
        dropoff: boolean,
        pet_no: number,
        pet_name: string,
        breed: string,
        color: string,
        appt_proc_id: number,
        appt_proc_name: string,
        appointment_note: string,
        code1: string,
        code2: string,
        code3: string,
        code4: string,
        appt_fulfill: string,
        status: string,
        tag_no: PetTagHistModel[],
        unscheduled: boolean
    ) {
        this.appointment_id = appointment_id;
        this.dropoff_time_needed = dropoff_time_needed;
        this.doctor_time_needed = doctor_time_needed;
        this.client_no = client_no;
        this.appointment_date = appointment_date;
        this.last_name = last_name;
        this.first_name = first_name;
        this.doctor = doctor;
        this.dropoff_time = dropoff_time;
        this.dropoff = dropoff;
        this.pet_no = pet_no;
        this.pet_name = pet_name;
        this.breed = breed;
        this.color = color;
        this.appt_proc_id = appt_proc_id;
        this.appt_proc_name = appt_proc_name;
        this.appointment_note = appointment_note;
        this.code1 = code1;
        this.code2 = code2;
        this.code3 = code3;
        this.code4 = code4;
        this.appt_fulfill = appt_fulfill;
        this.status = status;
        this.tag_no = tag_no; 
        this.unscheduled = unscheduled; 
    }
}


export class SelectedPetForApptModel {
    client_no: number
    pet_no: number
    pet_name: string
    appt_proc_code_1: string
    appt_proc_code_2: string
    code_1: string
    code_2: string
    appt_proc_code_total: number


    constructor(
        client_no: number,
        pet_no: number,
        pet_name: string,
        appt_proc_code_1: string,
        appt_proc_code_2: string,
        code_1: string,
        code_2: string,
        appt_proc_code_total: number,
    ) { 
        this.client_no = client_no
        this.pet_no = pet_no
        this.pet_name = pet_name
        this.appt_proc_code_1 = appt_proc_code_1
        this.appt_proc_code_2 = appt_proc_code_2
        this.code_1 = code_1
        this.code_2 = code_2
        this.appt_proc_code_total = appt_proc_code_total 
    }
}